import React from 'react';
import { connect } from 'react-redux';

import En from './__en';
import Vi from './__vi';
import Ja from './__ja';

function Gmail(props) {
    const { Intl } = props;
    return (
        <>
            {Intl.locale === 'en' && <En />}
            {Intl.locale === 'vi' && <Vi />}
            {Intl.locale === 'ja' && <Ja />}
        </>
    )
}

function mapStateToProps(state) {
    return {
        Intl: state.Intl,
    }
}
export default connect(mapStateToProps)(Gmail);